<template>
  <div class="shipment_stock_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <div style="padding:15px;width:100%;">
          <form @submit.prevent="addStock" style="padding:15px;">
            <div class="form-group">
              <label for="parent_model" class="package_item_label mb-3"
                >Items *</label
              >
              <button
                class="btn btn-sm btn-success add_btn ml-3"
                @click="addItem"
                type="button"
              >
                Add Item
              </button>

              <div v-for="(v, index) in $v.stock.$each.$iter" :key="index">
                <div class="form-group">
                  <div class="row">
                    <div class="col-5">
                      <label class="form_label"
                        >Model {{ parseInt(index) + 1 }}</label
                      >
                      <input
                        class="form-control stock_model"
                        v-model.trim="v.model.$model"
                        :class="{ 'is-invalid': v.model.$invalid && submit }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!v.model.required && submit"
                      >
                        Name is required.
                      </div>
                    </div>
                    <div class="col-3">
                      <label class="form_label"
                        >quantity {{ parseInt(index) + 1 }}</label
                      >
                      <input
                        class="form-control"
                        v-model.trim="v.quantity.$model"
                        :class="{ 'is-invalid': v.quantity.$invalid && submit }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!v.quantity.required && submit"
                      >
                        Quantity is required.
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!v.quantity.numeric && submit"
                      >
                        Quantity has to be a number.
                      </div>
                    </div>

                    <div class="col-3">
                      <label class="form_label"
                        >Expiry {{ parseInt(index) + 1 }}</label
                      >
                      <div
                        :class="{
                          'is-invalid': v.expiry_date.$invalid && submit
                        }"
                      >
                        <date-picker
                          input-class="form-control"
                          @change="setExpiryDate($event, index)"
                          @clear="setExpiryDate"
                          :value="v.expiry_date.$model"
                          :input-name="'shipping_date_' + index"
                          :first-day-of-week="1"
                          lang="en"
                          type="month"
                          format="YYYY-MM"
                        ></date-picker>
                      </div>

                      <div
                        class="invalid-feedback"
                        v-if="!v.expiry_date.required && submit"
                      >
                        Expiry Date is required.
                      </div>
                    </div>

                    <div class="col-1">
                      <button
                        class="btn btn-sm btn-danger delete_btn"
                        v-if="index > 0"
                        @click="deleteItem(index)"
                        type="button"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-btn variant="success" size="md" class="float-left" type="submit"
              >Add / Update Stock</b-btn
            >
            <b-btn
              variant="secondary"
              size="md"
              class="float-right"
              :to="'/shipments/'"
              >Cancel</b-btn
            >
          </form>
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, numeric } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import format from "date-fns/format";
import addYears from "date-fns/addYears";

export default {
  name: "shipment-stock",
  components: {
    DatePicker
  },
  data() {
    return {
      stock: [
        {
          model: "",
          quantity: "",
          expiry_date: format(addYears(new Date(), 2), "yyyy-MM")
        }
      ],
      submit: false,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Shipments", to: { name: "shipments" } },
        { text: "Add Shipment Stock", active: true }
      ]
    };
  },
  validations: {
    stock: {
      required,
      $each: {
        expiry_date: {
          required
        },
        model: {
          required
        },
        quantity: {
          required,
          numeric
        }
      }
    }
  },
  mounted: function() {
    this.getShipmentStock();
  },
  methods: {
    setExpiryDate(e, index) {
      this.stock[index].expiry_date = e ? format(e, "yyyy-MM") : null;
    },
    getShipmentStock() {
      let loader = this.$loading.show();
      this.$http
        .get(
          this.APIURL +
            this.BRAND +
            "/shipments/" +
            this.$route.params.id +
            "/stock"
        )
        .then(
          response => {
            if (response.data.length > 0) {
              this.stock = response.data;
            }
            loader.hide();
          },
          error => {
            console.log(error);
          }
        );
    },
    deleteItem(index) {
      this.stock.splice(index, 1);
    },
    convertToHtmlList(errors) {
      let htmlMessage = "";
      errors.forEach(function(error) {
        htmlMessage += error + "<br/>";
      });
      return htmlMessage;
    },
    addItem() {
      this.stock.push({
        model: "",
        quantity: "",
        expiry_date: format(addYears(new Date(), 2), "yyyy-MM")
      });
    },
    addStock() {
      this.submit = true;
      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();

        this.$http
          .post(
            this.APIURL +
              this.BRAND +
              "/shipments/" +
              this.$route.params.id +
              "/stock",
            { stock: this.stock }
          )
          .then(
            response => {
              if (response.data.status == "failed") {
                this.$swal({
                  title: "Failed!",
                  showConfirmButton: true,
                  html: this.convertToHtmlList(response.data.errors),
                  type: "error",
                  onClose: () => {
                    loader.hide();
                  }
                });
              } else {
                this.$swal({
                  title: "Success!",
                  showConfirmButton: false,
                  timer: 1000,
                  html:
                    "Shipment Stock added successfully, taking you back to shipment list.",
                  type: "success",
                  onClose: () => {
                    loader.hide();
                    this.$router.push({ name: "shipments" });
                  }
                });
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }
};
</script>
